"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const mutation = (0, client_1.gql) `
  mutation createTag($tag: TagInput!) {
    createTag(tag: $tag) {
      _id
      name
      createdAt
      updatedAt
    }
  }
`;
exports.default = mutation;
//# sourceMappingURL=createTag.mutation.js.map